import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { GetGeofenceResponseFilterSensitiveLog } from "../models/models_0";
import { de_GetGeofenceCommand, se_GetGeofenceCommand } from "../protocols/Aws_restJson1";
export { $Command };
export class GetGeofenceCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("LocationService", "GetGeofence", {})
    .n("LocationClient", "GetGeofenceCommand")
    .f(void 0, GetGeofenceResponseFilterSensitiveLog)
    .ser(se_GetGeofenceCommand)
    .de(de_GetGeofenceCommand)
    .build() {
}
